/* eslint-disable react/display-name */
import { Button, ButtonProps } from '@casavo/base-ui'
import cn from 'classnames'
import Link, { LinkProps } from 'next/link'
import React from 'react'

import { ConditionalWrapper } from '@/components/ConditionalWrapper'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

type LinkButtonProps = Omit<React.HTMLProps<HTMLAnchorElement>, 'label'> &
  LinkProps &
  ButtonProps & { isNextLink?: boolean }

export const ButtonLink: React.FC<LinkButtonProps> = ({
  Icon,
  ariaLabel,
  center,
  className,
  colorVariant,
  fullWidth,
  href,
  isNextLink = true,
  label,
  onClick,
  rel,
  sizeVariant,
  styleVariant,
  target,
  ...props
}) => {
  return (
    <ConditionalWrapper
      condition={isNextLink}
      wrapper={(children) => (
        <Link passHref href={href}>
          {children}
        </Link>
      )}
    >
      <a
        className={cn(sprinkles({ cursor: 'pointer', display: 'inline-block' }), className)}
        href={!isNextLink && href}
        rel={rel}
        target={target}
        onClick={onClick}
      >
        <Button
          asLink
          ariaLabel={ariaLabel}
          center={center}
          colorVariant={colorVariant}
          fullWidth={fullWidth}
          Icon={Icon}
          label={label}
          sizeVariant={sizeVariant}
          styleVariant={styleVariant}
          {...props}
        />
      </a>
    </ConditionalWrapper>
  )
}
